import * as Redux from 'redux';
import { PayersActionTypes, PayMethodsActionTypes, BillingResponseData } from './billing.types';
import * as BILLING_ACTION_TYPES from './billing.const';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { CountryCode, ProvinceCode } from '../geo/geo.types';
import { callApi } from '../util/ApiCaller';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const getPayers: Redux.ActionCreator<
  ReduxPromiseAction<
    PayersActionTypes, SimpleResponse<BillingResponseData>
  >
> = (): ReduxPromiseAction<PayersActionTypes, SimpleResponse<BillingResponseData>> => ({
  type: BILLING_ACTION_TYPES.GET_PAYERS,
  payload: callApi(
    process.env.REACT_APP_API + '/payer/list',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const createPayer: Redux.ActionCreator<
  ReduxPromiseAction<
    PayersActionTypes, SimpleResponse<BillingResponseData>
  >
> = (
  businessId: number, firstName: string, lastName: string, initial: string, address: string,
  city: string, country: CountryCode | '', province: ProvinceCode | '', postalCode: string, mobile1: string,
  mobile2: string, email: string): ReduxPromiseAction<PayersActionTypes, SimpleResponse<BillingResponseData>> => ({
    type: BILLING_ACTION_TYPES.REGISTER_PAYER,
    payload: callApi(
      process.env.REACT_APP_API + '/payer',
      true,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': pickAuthOrImpersonationToken()
        },
        body: JSON.stringify({
          businessId,
          firstName,
          lastName,
          initial,
          address,
          city,
          country,
          province,
          postalCode,
          mobile1,
          mobile2,
          email
        })
      }
    )
  });

export const updatePayer: Redux.ActionCreator<
  ReduxPromiseAction<
    PayersActionTypes, SimpleResponse<BillingResponseData>
  >
> = (
  businessId: number, id: number, firstName: string, lastName: string, initial: string,
  address: string, city: string, country: CountryCode | '', province: ProvinceCode | '', postalCode: string,
  mobile1: string, mobile2: string, email: string
): ReduxPromiseAction<PayersActionTypes, SimpleResponse<BillingResponseData>> => ({
  type: BILLING_ACTION_TYPES.UPDATE_PAYER,
  payload: callApi(
    process.env.REACT_APP_API + '/payer',
    true,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({
        businessId, id, firstName, lastName, initial, address, city, country, province, postalCode, mobile1,
        mobile2, email
      })
    }
  )
});

export const getPayMethods: Redux.ActionCreator<
  ReduxPromiseAction<
    PayMethodsActionTypes, SimpleResponse<BillingResponseData>
  >
> = (payerId: number): ReduxPromiseAction<PayMethodsActionTypes, SimpleResponse<BillingResponseData>> => ({
  type: BILLING_ACTION_TYPES.GET_PAYMETHODS,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/method/list/' + payerId,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const getAllPayMethods: Redux.ActionCreator<
  ReduxPromiseAction<
    PayMethodsActionTypes, SimpleResponse<BillingResponseData>
  >
> = (): ReduxPromiseAction<PayMethodsActionTypes, SimpleResponse<BillingResponseData>> => ({
  type: BILLING_ACTION_TYPES.GET_PAYMETHODS,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/method/list/',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const createPayMethod: Redux.ActionCreator<
  ReduxPromiseAction<
    PayMethodsActionTypes, SimpleResponse<BillingResponseData>
  >
> = (
  payerId: number, paymentMethodType: string, accountHolderName: string, financialInstitutionName: string,
  transitNumber: string, financialInstitutionNumber: string, bankAccountNumber: string, cardHolderName: string,
  cardNumber: string, expiryMonth: string, expiryYear: string, cvc: string
): ReduxPromiseAction<PayMethodsActionTypes, SimpleResponse<BillingResponseData>> => ({
  type: BILLING_ACTION_TYPES.REGISTER_PAYMETHODS,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/method',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({
        payerId, paymentMethodType, accountHolderName, financialInstitutionName,
        transitNumber, financialInstitutionNumber, bankAccountNumber, cardHolderName, cardNumber,
        expiryMonth, expiryYear, cvc
      })
    }
  )
});

export const removePayMethod: Redux.ActionCreator<
  ReduxPromiseAction<
    PayMethodsActionTypes, SimpleResponse<BillingResponseData>
  >
> = (paymentMethodId: number): ReduxPromiseAction<PayMethodsActionTypes, SimpleResponse<BillingResponseData>> => ({
  type: BILLING_ACTION_TYPES.REMOVE_PAYMETHODS,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/method/' + paymentMethodId,
    true,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  ),
  meta: { id: paymentMethodId }
});



// WEBPACK FOOTER //
// ./src/billing/billing.actions.tsx